export const modernAntraege = [
  {
    "user": {
      "name": "gh1",
      "vmnr": "99999"
    },
    "submitTime": "11.9.2018, 12:14:25",
    "angebotsnummer": "9610350155",
    "guid": "8066b9d2-7e1e-4818-a66f-45a179f06952",
    "pdfpfad": "/maklerportalneu/api/download/72",
    "civilServant": false,
    "categories": [
      "V"
    ],
    "family": "MPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Fahrer",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "PRE-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": false,
    "ssrdisabled": true,
    "ssrsb": "SB150",
    "cyberselected": false,
    "cyberdisabled": true,
    "cybersb": "SB150",
    "zwselected": false,
    "zwdisabled": true,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "",
      "hausnummer": "",
      "ort": "",
      "plz": "",
      "bruttojahresmiete": "",
      "land": "",
      "sb": "",
      "price": 0
    },
    "vermselected": false,
    "vermdisabled": true,
    "vermsb": "SB300",
    "vermwohnungen": [
      {
        "beschreibung": "Wohneinheit 1",
        "strasse": "",
        "hausnummer": "",
        "ort": "",
        "plz": "",
        "land": "Deutschland",
        "sb": "SB300",
        "bruttojahresmiete": null,
        "price": 0,
        "hasError": true
      }
    ],
    "vermvalid": false,
    "productLine": "PRE",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "F",
      "titel": "",
      "firstname": "Test",
      "lastname": "Test",
      "strasse": "sdfg",
      "hausnummer": "456",
      "adresszusatz": "",
      "plz": "45654",
      "ort": "sdf",
      "geburt": "05.05.1955",
      "beruf": "Abrechnungstechniker/in",
      "email": "test@mail.com",
      "mobil": "",
      "telefon": "+49",
      "staat": "Deutschland",
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": [
        "email",
        "telefon",
        "mobil",
        "staat",
        "plz",
        "ort",
        "strasse"
      ],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "geburt": "",
      "beruf": null,
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": [
        "beruf",
        "email",
        "telefon",
        "mobil",
        "staat"
      ],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "strasse": "",
      "plz": "",
      "ort": "",
      "geburt": ""
    },
    "iban": "",
    "bic": "",
    "inhabertyp": "VN",
    "rechnungszahler": "J",
    "zahlweise": "1",
    "versicherungsbeginn": "06.06.2019",
    "hauptfaelligkeit": null,
    "aula": "J",
    "invitatio": "N",
    "werbezwecke": null,
    "anmerkungen": "",
    "files": [],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [],
    "producterror": false,
    "art": "Antrag"
  },
  {
    "user": {
      "name": "gh1",
      "vmnr": "99999"
    },
    "submitTime": "11.9.2018, 13:00:20",
    "angebotsnummer": "6344318057",
    "guid": "aba299dd-3d62-4179-9669-e27f12bb7674",
    "pdfpfad": "/maklerportalneu/api/download/78",
    "civilServant": false,
    "categories": [
      "V"
    ],
    "family": "MPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Fahrer",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "PRE-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": false,
    "ssrdisabled": true,
    "ssrsb": "SB150",
    "cyberselected": false,
    "cyberdisabled": true,
    "cybersb": "SB150",
    "zwselected": false,
    "zwdisabled": true,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "",
      "hausnummer": "",
      "ort": "",
      "plz": "",
      "bruttojahresmiete": "",
      "land": "",
      "sb": "",
      "price": 0
    },
    "vermselected": false,
    "vermdisabled": true,
    "vermsb": "SB300",
    "vermwohnungen": [
      {
        "beschreibung": "Wohneinheit 1",
        "strasse": "",
        "hausnummer": "",
        "ort": "",
        "plz": "",
        "land": "Deutschland",
        "sb": "SB300",
        "bruttojahresmiete": null,
        "price": 0,
        "hasError": true
      }
    ],
    "vermvalid": false,
    "productLine": "PRE",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "F",
      "titel": "",
      "firstname": "Test",
      "lastname": "Test",
      "strasse": "sdfas",
      "hausnummer": "43",
      "adresszusatz": "",
      "plz": "44444",
      "ort": "asd",
      "geburt": "05.05.1955",
      "beruf": "Abrechnungstechniker/in",
      "email": "test@mail.com",
      "mobil": "",
      "telefon": "+49",
      "staat": "Deutschland",
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": [
        "email",
        "telefon",
        "mobil",
        "staat",
        "plz",
        "ort",
        "strasse"
      ],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "geburt": "",
      "beruf": null,
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": [
        "beruf",
        "email",
        "telefon",
        "mobil",
        "staat"
      ],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "strasse": "",
      "plz": "",
      "ort": "",
      "geburt": ""
    },
    "iban": "",
    "bic": "",
    "inhabertyp": "VN",
    "rechnungszahler": "J",
    "zahlweise": "1",
    "versicherungsbeginn": "06.06.2019",
    "hauptfaelligkeit": null,
    "aula": "J",
    "invitatio": "N",
    "werbezwecke": null,
    "anmerkungen": "",
    "files": [],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [],
    "producterror": false,
    "art": "Antrag"
  },
  {
    "user": {
      "name": "gh1",
      "vmnr": "99999"
    },
    "submitTime": "11.9.2018, 14:48:33",
    "angebotsnummer": "1154311655",
    "guid": "534b6711-1d74-45aa-b45a-b21fb7346d49",
    "pdfpfad": "/maklerportalneu/api/download/92",
    "civilServant": false,
    "categories": [
      "V"
    ],
    "family": "MPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Fahrer",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "EXP-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": false,
    "ssrdisabled": true,
    "ssrsb": "SB150",
    "cyberselected": false,
    "cyberdisabled": true,
    "cybersb": "SB150",
    "zwselected": false,
    "zwdisabled": true,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "",
      "hausnummer": "",
      "ort": "",
      "plz": "",
      "bruttojahresmiete": "",
      "land": "",
      "sb": "",
      "price": 0
    },
    "vermselected": false,
    "vermdisabled": true,
    "vermsb": "SB300",
    "vermwohnungen": [
      {
        "beschreibung": "Wohneinheit 1",
        "strasse": "",
        "hausnummer": "",
        "ort": "",
        "plz": "",
        "land": "Deutschland",
        "sb": "SB300",
        "bruttojahresmiete": null,
        "price": 0,
        "hasError": true
      }
    ],
    "vermvalid": false,
    "productLine": "EXP",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "F",
      "titel": "",
      "firstname": "Lisa",
      "lastname": "Müller",
      "strasse": "sdf",
      "hausnummer": "4",
      "adresszusatz": "",
      "plz": "44444",
      "ort": "asdf",
      "geburt": "04.04.1944",
      "beruf": "Abgeordnete/r",
      "email": "t@sd.fd",
      "mobil": "",
      "telefon": "+49",
      "staat": "Deutschland",
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": [
        "email",
        "telefon",
        "mobil",
        "staat",
        "plz",
        "ort",
        "strasse"
      ],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "geburt": "",
      "beruf": null,
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": [
        "beruf",
        "email",
        "telefon",
        "mobil",
        "staat"
      ],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "strasse": "",
      "plz": "",
      "ort": "",
      "geburt": ""
    },
    "iban": "",
    "bic": "",
    "inhabertyp": "VN",
    "rechnungszahler": "J",
    "zahlweise": "1",
    "versicherungsbeginn": "06.06.2019",
    "hauptfaelligkeit": null,
    "aula": "J",
    "invitatio": "N",
    "werbezwecke": null,
    "anmerkungen": "",
    "files": [],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [
      "Bitte überprüfen Sie Ihre Eingaben."
    ],
    "producterror": false,
    "art": "Antrag"
  },
  {
    "user": {
      "name": "gh1",
      "vmnr": "99999"
    },
    "submitTime": "11.9.2018, 14:48:33",
    "angebotsnummer": "1954311655",
    "guid": "534b6711-1d74-45aa-b45a-b21fb7346d49",
    "pdfpfad": "/maklerportalneu/api/download/92",
    "civilServant": false,
    "categories": [
      "V"
    ],
    "family": "MPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Fahrer",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "EXP-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": false,
    "ssrdisabled": true,
    "ssrsb": "SB150",
    "cyberselected": false,
    "cyberdisabled": true,
    "cybersb": "SB150",
    "zwselected": false,
    "zwdisabled": true,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "",
      "hausnummer": "",
      "ort": "",
      "plz": "",
      "bruttojahresmiete": "",
      "land": "",
      "sb": "",
      "price": 0
    },
    "vermselected": false,
    "vermdisabled": true,
    "vermsb": "SB300",
    "vermwohnungen": [
      {
        "beschreibung": "Wohneinheit 1",
        "strasse": "",
        "hausnummer": "",
        "ort": "",
        "plz": "",
        "land": "Deutschland",
        "sb": "SB300",
        "bruttojahresmiete": null,
        "price": 0,
        "hasError": true
      }
    ],
    "vermvalid": false,
    "productLine": "EXP",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "F",
      "titel": "",
      "firstname": "DUPLIKAT",
      "lastname": "MODERN",
      "strasse": "sdf",
      "hausnummer": "4",
      "adresszusatz": "",
      "plz": "44444",
      "ort": "asdf",
      "geburt": "04.04.1944",
      "beruf": "Abgeordnete/r",
      "email": "t@sd.fd",
      "mobil": "",
      "telefon": "+49",
      "staat": "Deutschland",
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": [
        "email",
        "telefon",
        "mobil",
        "staat",
        "plz",
        "ort",
        "strasse"
      ],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "geburt": "",
      "beruf": null,
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        },
        {
          "zum": null,
          "vorversicherer": "",
          "vscheinnr": "",
          "von": "VN"
        }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": [
        "beruf",
        "email",
        "telefon",
        "mobil",
        "staat"
      ],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "strasse": "",
      "plz": "",
      "ort": "",
      "geburt": ""
    },
    "iban": "",
    "bic": "",
    "inhabertyp": "VN",
    "rechnungszahler": "J",
    "zahlweise": "1",
    "versicherungsbeginn": "06.06.2019",
    "hauptfaelligkeit": null,
    "aula": "J",
    "invitatio": "N",
    "werbezwecke": null,
    "anmerkungen": "",
    "files": [],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [
      "Bitte überprüfen Sie Ihre Eingaben."
    ],
    "producterror": false,
    "art": "Antrag"
  }
];

export const legacyAntraege = [
  {
    "vn": {
      "firstname": "Test",
      "lastname": "SuS Laufzeit DREI Jahr",
      "plz": "98527",
      "ort": "Suhl"
    },
    "productLine": "Privat",
    "scope": "PBWV",
    "submitTime": "2018-09-07T08:49:48",
    "angebotsnummer": "0155004512",
    "pdfpfad": "/maklerportal/getangpdf.aspx?vorgang=0155004512"
  },
  {
    "vn": {
      "firstname": "DUPLIKAT",
      "lastname": "LEGACY",
      "plz": "98527",
      "ort": "Suhl"
    },
    "productLine": "Privat",
    "scope": "PBWV",
    "submitTime": "2018-09-07T08:49:48",
    "angebotsnummer": "1954311655",
    "pdfpfad": "/maklerportal/getangpdf.aspx?vorgang=0155004512"
  },
  {
    "vn": {
      "firstname": "Maximilian",
      "lastname": "Patternus-Alt",
      "plz": "82194",
      "ort": "Gröbenzell"
    },
    "productLine": "Privat",
    "scope": "PB",
    "submitTime": "2018-11-14T16:45:57",
    "angebotsnummer": "7570413585",
    "pdfpfad": "/maklerportal/getangpdf.aspx?vorgang=7570413585"
  }
];
